import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../services/DataTable";

export interface IIndustryModel {
    id: number;
    name: string;
}

export class Industry{

    private API_ROOT:string = '/industry';
    constructor(private http: Http) {}

    getList(filter?: IDataFilter) {
        let params: URLSearchParams = new URLSearchParams();
        for(let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http.get(this.API_ROOT, new RequestOptions({
            search: params
        }))
    }
}


// WEBPACK FOOTER //
// ./src/app/models/industry.ts